import { render, staticRenderFns } from "./HomeIndexNews.vue?vue&type=template&id=6d9a4b07&scoped=true&"
import script from "./HomeIndexNews.vue?vue&type=script&lang=js&"
export * from "./HomeIndexNews.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndexNews.vue?vue&type=style&index=0&id=6d9a4b07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a4b07",
  null
  
)

export default component.exports